import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface TypedConfirmationDialogData {
  title: string;
  message: string;
  confirmationText: string;
  confirmLabel: string;
}

@Component({
  selector: 'app-typed-confirmation-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule],
  templateUrl: './typed-confirmation-dialog.component.html',
})
export class TypedConfirmationDialogComponent {
  typedValue = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: TypedConfirmationDialogData,
    dialogRef: MatDialogRef<TypedConfirmationDialogComponent>,
  ) {
    dialogRef.addPanelClass('br-dialog-panel');
  }
}
